import { render, staticRenderFns } from "./ChooseSystem.vue?vue&type=template&id=66aa1fa6&"
import script from "./ChooseSystem.vue?vue&type=script&lang=js&"
export * from "./ChooseSystem.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSystem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports